import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const topPractitioner = createAsyncThunk(
  "GET_TOP_PRACTITIONER",
  async (userData) => {
    const payload = { ...userData };
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/summary/top-practitioner`,
        payload,
        config
      );
      let status = "success";
      let data_res = {
        status: status,
        message: response,
      };
      return data_res;
    } catch (error) {
      let status = "error";
      let data_error = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data_error;
    }
  }
);

const TopPractitionerSlice = createSlice({
  name: "GET_TOP_PRACTITIONER_SLICE",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(topPractitioner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(topPractitioner.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === "success") {
          state.data = action.payload.message.data;
        }
      })
      .addCase(topPractitioner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default TopPractitionerSlice.reducer;
